import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, inject, input, model, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiModule } from 'app/shared/ui';
import { OverlayRef } from 'app/shared/ui/overlays';
import { Column } from './comparables-table.component';


@Component({
    selector: 'customize-columns-modal',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        UiModule,
    ],
    styles: [
        `
        .form-check-label {
            user-select: none;
        }
        `
    ],
    template: `
        <ui-modal>
            <modal-header>
                Customize Columns
            </modal-header>
            <modal-body cdkScrollable>
                <form id="columnsForm" (ngSubmit)="onSubmit()" (reset)="onReset($event)">
                    <div [formGroup]="form">
                        @if (defaultOrderedColumns()) {
                            <div class="d-flex">
                                <button type="reset" class="btn btn-link ml-auto">
                                    Reset Settings
                                </button>
                           </div>
                        }
                        <div formGroupName="columns" class="list-group" cdkDropList [cdkDropListData]="columns()" (cdkDropListDropped)="onDrop($event)">
                            @for (column of columns(); track column.key) {
                                <div class="list-group-item d-flex align-items-center" cdkDrag>
                                    <ui-checkbox [formControlName]="column.key">
                                        <div [innerHTML]="column.title"></div>
                                    </ui-checkbox>
                                    @if (column.tip) {
                                        <i class="fa fa-question-circle ml-2" [tooltip]="column.tip"></i>
                                    }
                                    <span cdkDragHandle class="cursor-move ml-auto">
                                        <i class="fa fa-arrows"></i>
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                </form>
            </modal-body>
            <modal-footer [formGroup]="form">
                <button class="btn btn-secondary" title="Close this modal discarding all changes" (click)="onCancel()">
                    Cancel
                </button>
                <ui-checkbox class="ml-auto" formControlName="saveAsPreset">
                    Save as preset
                </ui-checkbox>
                <button type="submit" form="columnsForm" class="btn btn-success">
                    Customize
                </button>
            </modal-footer>
        </ui-modal>
    `,
})
export class CustomizeColumnsModalComponent implements OnInit {

    columns = model.required<Column[]>();

    defaultOrderedColumns = input<Column[]>();

    save = input(true);

    form: FormGroup;

    private overlayRef = inject(OverlayRef);

    ngOnInit() {
        this.columns.set([...this.columns()]);
        const columnsControls = new FormGroup({});
        for (const column of this.columns()) {
            columnsControls.addControl(column.key, new FormControl(column.selected));
        }
        this.form = new FormGroup({
            columns: columnsControls,
            saveAsPreset: new FormControl(this.save()),
        });
    }

    onDrop(event: CdkDragDrop<Column[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    onSubmit() {
        if (this.form.invalid) {
            return;
        }
        const value = this.form.value;
        const columns = this.columns().map(c => ({ ...c, selected: value.columns[c.key] }));
        this.overlayRef.close({ columns, saveAsPreset: value.saveAsPreset });
    }

    onReset(event: Event) {
        event.preventDefault();
        const defaults = this.defaultOrderedColumns();
        if (defaults) {
            this.columns.set([...defaults]);
            this.form.reset({
                columns: Object.fromEntries(this.columns().map(c => [c.key, c.selected])),
                saveAsPreset: this.save(),
            });
        }
    }

    onCancel() {
        this.overlayRef.dismiss('cancel');
    }
}
